import React, { lazy, Suspense, useContext, useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../AdminPortal/AdminErrorFallback/ErrorFallback";
import SkeletonAdmin from "../../AdminPortal/AdminSkeletons/SkeletonAdmin";

// LAYOUTS
import MainLayout from "../../Common/Layout/MainLayout";
import AdminLayout from "../../Common/Layout/AdminLayout";
import MemberLayout from "../../Common/Layout/MemberLayout";

// MAIN PORTAL
// import Registration from "../../MainPortal/Applications/Registration";
import Contact from "../../MainPortal/Contact/Contact";
import Guide from "../../MainPortal/Guide/Guide";

// APPLICATION
import Applications from "../../AdminPortal/Applications/Applications";
import RegionalApprovals from "../../AdminPortal/Applications/RegionalApprovals";
import RegionForm from "../../AdminPortal/Applications/RegionForm";
import DopApprovals from "../../AdminPortal/Applications/DopApprovals";
import DopForm from "../../AdminPortal/Applications/DopForm";
import ApprovalForm from "../../AdminPortal/Applications/ApprovalForm";
import ViewApplication from "../../AdminPortal/Applications/ViewApplication";
// import RegionalMembership from '../Membership/RegionalMembership';
import DeclinedApplications from "../../AdminPortal/Applications/DeclinedApplications";

// OPERATIONS
import OperationsReport from "../../AdminPortal/Operations/OperationsReport";
import ActivationRequests from "../../AdminPortal/Operations/ActivationRequests";
import UpdateRequests from "../../AdminPortal/Operations/UpdateRequests";
import ContactMessage from "../../AdminPortal/Operations/ContactMessage";
import ReplyMessage from "../../AdminPortal/Operations/ReplyMessage";
import RegionalReportList from "../../AdminPortal/Operations/RegionalReportList";
import ViewRegionalReport from "../../AdminPortal/Operations/ViewRegionalReport";
import ViewConsolidatedReport from "../../AdminPortal/Operations/ViewConsolidatedReport";

// CARD MANAGEMENT
import GlobalCards from "../../AdminPortal/Cards/GlobalCards";
import PendingCards from "../../AdminPortal/Cards/PendingCards";
import PendingConfirmation from "../../AdminPortal/Cards/PendingConfirmation";
import ViewCard from "../../AdminPortal/Cards/ViewCard";

// LOGINS
import Login from "../../AdminPortal/Login/Login";
import MainLogin from "../../MainPortal/MainPage/MainLogin";

// CONTEXT PROVIDERS
import AuthContext from "../../../context/AuthProvider";
import MemberContext from "../../../context/MemberProvider";

// PERSISTENCE LOGIN
import PersistLogin from "../PersistLogin/PersistLogin";
import MemPersistLogin from "../PersistLogin/MemPersistLogin";

// USER REQUIRED AUTHENTICATION
import RequireAuth from "../RequireAuth/RequireAuth";
import RequireMember from "../RequireAuth/RequireMember";

import UserRoles from "../../../hooks/userRoles";
import PasswordSetup from "../../AdminPortal/PasswordManagement/PasswordSetup";
import Roles from "../../AdminPortal/Roles/Roles";
import Unauthorized from "../../AdminPortal/Unauthorized/Unauthorized";
import MultiForm from "../../Common/Billing/MultiForm";
import Table1 from "../Tables/Table1";
import Template from "../Template/Template";
import Form1 from "../../AdminPortal/Forms/Form1";
import ChangeForm from "../../AdminPortal/Forms/ChangeForm";
import BankHome from "../../Common/Banks/BankHome";
import "../../../App.css";
import MyForm from "../../AdminPortal/Forms/MyForm";

// ACCOUNTS
import ManualReceipt from "../../AdminPortal/Accounts/Receipts/ManualReceipt";
import PaymentTransactions from "../../AdminPortal/Accounts/Payments/PaymentTransactions";
import PaymentByPeriod from "../../AdminPortal/Accounts/Payments/PaymentByPeriod";
import ViewPayment from "../../AdminPortal/Accounts/Payments/ViewPayment";
import PaymentByMonth from "../../AdminPortal/Accounts/Payments/PaymentByMonth";
import PaymentByMode from "../../AdminPortal/Accounts/Payments/PaymentByMode";
import PaymentClearance from "../../AdminPortal/Accounts/Payments/PaymentClearance";

// PAYMENT TYPES
import PaymentTypes from "../../AdminPortal/Accounts/Payments/PaymentTypes/PaymentTypes";
import AddPaymentType from "../../AdminPortal/Accounts/Payments/PaymentTypes/AddPaymentType";
import EditPaymentType from "../../AdminPortal/Accounts/Payments/PaymentTypes/EditPaymentType";
import ViewPaymentType from "../../AdminPortal/Accounts/Payments/PaymentTypes/ViewPaymentType";

// YEARLY PAYMENT
import YearlyPayments from "../../AdminPortal/Accounts/Payments/YearlyPayments/YearlyPayments";
import AddYearlyPayment from "../../AdminPortal/Accounts/Payments/YearlyPayments/AddYearlyPayment";
import EditYearlyPayment from "../../AdminPortal/Accounts/Payments/YearlyPayments/EditYearlyPayment";
import ViewYearlyPayment from "../../AdminPortal/Accounts/Payments/YearlyPayments/ViewYearlyPayment";

// LEDGER ACCOUNTS
import CreateLedgers from "../../AdminPortal/Accounts/Ledgers/CreateLedgers";
import LedgerAccounts from "../../AdminPortal/Accounts/Ledgers/LedgerAccounts";
import GoodStanding from "../../AdminPortal/Accounts/Ledgers/GoodStanding";
import InArrears from "../../AdminPortal/Accounts/Ledgers/InArrears";
import PartPayment from "../../AdminPortal/Accounts/Ledgers/PartPayment";
import ViewLedger from "../../AdminPortal/Accounts/Ledgers/ViewLedger";

// EXPENDITURE
import Expenditure from "../../AdminPortal/Accounts/Expenditure/Expenditure";

// REVENUE
import Revenue from "../../AdminPortal/Accounts/Revenue/Revenue";

// MEMBER PORTAL
import Home from "../../MemberPortal/Dashboard/Home";
import MemberDashboard from "../../MemberPortal/Dashboard/MemberDashboard";
import ContactProforum from "../../MemberPortal/Contact/ContactProforum";

import MemberStatement from "../../MemberPortal/Statement/MemberStatement";

// import Profile from "../../MemberPortal/Profile/Profile";
import UpdateProfile from "../../MemberPortal/Profile/UpdateProfile";
// import ViewMember from "../../MemberPortal/Profile/ViewMember";
import MemberPassword from "../../MemberPortal/Password/MemberPassword";
import MemberLedger from "../../MemberPortal/Ledger/MemberLedger";
import MemberPaymentTransactions from "../../MemberPortal/PaymentTransactions/MemberPaymentTransactions";

// GLOBAL MEMBERSHIP
// import ViewGlobalMember from "../../AdminPortal/Members/ViewMember";
import MemberUpdate from "../../AdminPortal/Members/MemberUpdate";
import MandatoryPayments from "../../MemberPortal/Dashboard/MandatoryPayments";
import OtherPayments from "../../MemberPortal/Dashboard/OtherPayments";
import ChangePassword from "../../MemberPortal/Password/ChangePassword";
import PdfServices from "../../MemberPortal/Statement/PdfService";
import MemberLogout from "../../MemberPortal/Logout/MemberLogout";
import AdminLogout from "../../AdminPortal/Logout/AdminLogout";

// REGIONAL MEMBERSHIP
import RegionalMembers from "../../AdminPortal/Members/RegionalMembers/Membership/RegionalMembers";
// import ViewRegionalMember from "../../AdminPortal/Members/RegionalMembers/Membership/ViewRegionalMember";
import ActiveRegionalMembers from "../../AdminPortal/Members/RegionalMembers/Membership/ActiveRegionalMembers";
import InactiveRegionalMembers from "../../AdminPortal/Members/RegionalMembers/Membership/InactiveRegionalMembers";
import RegionalLedgerAccounts from "../../AdminPortal/Accounts/Ledgers/RegionalLedgers/RegionalLedgerAccounts";
import ViewRegionalLedger from "../../AdminPortal/Accounts/Ledgers/RegionalLedgers/ViewRegionalLedger";
import RegionalPaymentTransactions from "../../AdminPortal/Accounts/Payments/RegionalPayments/RegionalPaymentTransactions";
import ViewRegionalPayment from "../../AdminPortal/Accounts/Payments/RegionalPayments/ViewRegionalPayment";
import ViewActiveMember from "../../AdminPortal/Members/ViewActiveMember";
import ViewInactiveMember from "../../AdminPortal/Members/ViewInactiveMember";
import Pager from "../Pager/Pager";
import AccountReports from "../../AdminPortal/Accounts/Reports/AccountReports";

import MainTwoMTwoPayment from "../../MainPortal/Payment/MainTwoMTwoPayment";
import MainRegularPayment from "../../MainPortal/Payment/MainRegularPayment";
import MemberTwoMTwoPayment from "../../MemberPortal/Payments/MemberTwoMTwoPayment";
import MemberRegularPayment from "../../MemberPortal/Payments/MemberRegularPayment";
import ViewPaymentClearance from "../../AdminPortal/Accounts/Payments/ViewPaymentClearance";
import VerifySecretCode from "../../MainPortal/ForgotPassword/VerifySecretCode";
import ResetPortalPassword from "../../MainPortal/ForgotPassword/ResetPortalPassword";
import NotFoundPage from "../NotFoundPages/NotFoundPage";
import CaptureOldMembers from "../../AdminPortal/Applications/CaptureOldMembers";
import ChangeRegion from "../../AdminPortal/Applications/ChangeRegion";
import AmendRegion from "../../AdminPortal/Applications/AmendRegion";
import FindMember from "../../AdminPortal/Members/FindMember";
import TwomtwoPayments from "../../AdminPortal/Accounts/Reports/TwomtwoPaymentsReport";
import LedgerBalances from "../../AdminPortal/Accounts/Reports/LedgerBalances";
import Whatsapp from "../Whatsapp/Whatsapp";
import DialogForm from "../../MainPortal/DialogForm/DialogForm";
// import TryLogin from "../../AdminPortal/Login/Login";
import ResetUserPassword from "../../AdminPortal/PasswordManagement/ResetUserPassword";
import MembershipReports from "../../AdminPortal/Reports/MembershipReports";
import RegionalMembershipReport from "../../AdminPortal/Reports/RegionalMembershipReport";

import DisplayMember from "../../AdminPortal/Members/MembershipView/DisplayMember";
import AdmissionFeePayment from "../../MainPortal/Payment/AdmissionFeePayment";
import CreatePortalUser from "../../AdminPortal/Users/CreatePortalUser";
import UpdateClearance from "../../AdminPortal/Accounts/Payments/UpdateClearance";
import Donations from "../../MainPortal/Payment/Donations";
import DisplayProfile from "../../MemberPortal/Profile/MemberView/DisplayProfile";
import DisplayRegionalMember from "../../AdminPortal/Members/RegionalMembers/RegionalMembershipView/DisplayRegionalMember";
// import NonMMSPayments from "../../AdminPortal/Accounts/Payments/NewApplicantMomoPayments";
import PaymentReports from "../../AdminPortal/Reports/PaymentReports";
import MandatoryPaymentsReport from "../../AdminPortal/Accounts/Reports/MandatoryPaymentsReport";
import MandatoryPaymentsByDate from "../../AdminPortal/Accounts/Reports/MandatoryPaymentsByDate";
import MandatoryPaymentsByMonth from "../../AdminPortal/Accounts/Reports/MandatoryPaymentsByMonth";
// import DeactivateMember from "../../AdminPortal/Members/Management/MemberActivationManagement";
import UserActivationManagement from "../../AdminPortal/Users/UserActivationManagement";
import ActivationManagement from "../../AdminPortal/Members/Management/MemberActivationManagement";
import ResetMemberPassword from "../../AdminPortal/PasswordManagement/ResetMemberPassword";
import RegistrationForm from "../../MainPortal/Applications/Registration/RegistrationForm";
import { Messages } from "../../MainPortal/Applications/Registration/Messages";
import { MyCv } from "../../MemberPortal/Cvs/MyCv";
import { ViewCV } from "../../MemberPortal/Cvs/ViewCV";
import { ReplaceCV } from "../../MemberPortal/Cvs/ReplaceCV";
import { CVManagement } from "../../AdminPortal/CVManagement/CVManagement";
import NewApplicantMomoPayments from "../../AdminPortal/Accounts/Payments/NewApplicantMomoPayments";
import ExistingMemberMoMoPayments from "../../AdminPortal/Accounts/Payments/ExistingMemberMoMoPayments";
import { UploadMemberCV } from "../../AdminPortal/CVManagement/UploadMemberCV";
import PaginatedCard from "../../AdminPortal/Cards/PaginatedCard";
import { PaginatingCard } from "../../AdminPortal/Cards/PaginatingCard";
import { PaginatedMembers } from "../../AdminPortal/Members/PaginatedMembers";
import DuesPayment from "../../MainPortal/Payment/DuesPayment";
import AdmissionFees from "../../MainPortal/Payment/AdmissionFees";
import SpecialDonations from "../../MainPortal/Payment/SpecialDonations";
import ProfilePictuires from "../../AdminPortal/Members/ProfilePicture/ProfilePictures";
import UpdateProfilePictuire from "../../MemberPortal/Member/UpdateProfilePicture";
import PaginationText from "../../MainPortal/Elections/Pagination/PaginationText";
import LandingPage from "../../MainPortal/MainPage/LandingPage";
import MemberLogin from "../../AdminPortal/Login/MemberLogin";
import UpdateLedger from "../../AdminPortal/Accounts/Ledgers/UpdateLedger";
import Callback from "../../AdminPortal/Callback/Callback";

// import ElectionMainPage from "../../MainPortal/Elections/Main/ElectionMainPage";
// import ElectionInformation from "../../MainPortal/Elections/Main/ElectionInformation";
// import MyPage from "../../MainPortal/Elections/Main/MyPage";

// import { PdfViewer } from "../../MemberPortal/Cvs/PdfViewer";

const PollingAgents = lazy(() =>
	import("../../AdminPortal/PollingAgents/PollingAgents")
);
const Dashboard = lazy(() => import("../../AdminPortal/Dashboard/Dashboard"));
const GeneralSetup = lazy(() =>
	import("../../AdminPortal/Setup/GeneralSetup/GeneralSetup")
);
const AdminUsers = lazy(() => import("../../AdminPortal/Users/AdminUsers"));
const OnlineUsers = lazy(() => import("../../AdminPortal/Users/OnlineUsers"));
const PortalUsers = lazy(() => import("../../AdminPortal/Users/PortalUsers"));
const RegionalPresidents = lazy(() =>
	import("../../AdminPortal/Users/RegionalPresidents")
);


const Members = lazy(() => import("../../AdminPortal/Members/GlobalMembers"));
const ActiveMembers = lazy(() =>
	import("../../AdminPortal/Members/ActiveMembers")
);

const DuplicateRecords = lazy(() => import("../../AdminPortal/Members/DuplicateRecords"));
const InactiveMembers = lazy(() =>
	import("../../AdminPortal/Members/InactiveMembers")
);
const FindRegion = lazy(() =>
	import("../../AdminPortal/Members/RegionalMembers/FindRegion")
);

function App() {
	const location = useLocation();
	const fullPath = location.pathname;

	const { auth } = useContext(AuthContext);
	const { mem } = useContext(MemberContext);

	let userLogin = window.location.search.substring(6).split("&");
	let message = window.location.search.substring(6).split("&");
	let paymtPF = fullPath.split("/")[2];
	let receiptNo = fullPath.split("/")[2];
	let key = fullPath.split("=")[1];

	let applicationMobileNumber = window.location.search
		.substring(8)
		.split("&");

	const navigate = useNavigate();

	return (
    <Routes>
      {/* <Route path="/pdf_viewer" element={<PdfViewer />} /> */}
      <Route path="/login" element={<Login />} />
      <Route path="/member_login" element={<MemberLogin />} />
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/set_password"
        element={<PasswordSetup user={userLogin} />}
      />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route path="/member_logout" element={<MemberLogout />} />
      <Route path="/admin_logout" element={<AdminLogout />} />

      {/* PUBLIC ROUTES */}
      <Route path="/" exact element={<MainLayout />}>
        {/* <Route path="/" element={<MainLogin />} /> */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/verify_secret_code" element={<VerifySecretCode />} />
        <Route
          path="/reset_portal_password/:id"
          element={<ResetPortalPassword />}
        />

        <Route
          path="/set_member_password"
          element={<MemberPassword user={userLogin} />}
        />
        {/* <Route path="/registration" element={<Registration />} /> */}
        <Route path="/registration" element={<RegistrationForm />} />
        <Route path="/successful_application" element={<Messages />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/portal_guide" element={<Guide />} />
        {/* <Route path="/election_information" element={<ElectionInformation />} />
				<Route path="/my_page" element={<MyPage />} /> */}
        <Route path="/pager" element={<PaginationText />} />
        <Route
          path="/admission_payments"
          exact
          element={<AdmissionFeePayment mobile={applicationMobileNumber} />}
        />
        <Route path="/main_2m2_payments" element={<MainTwoMTwoPayment />} />
        <Route path="/special_donations" element={<SpecialDonations />} />
        <Route path="/admission_fees" element={<AdmissionFees />} />
        <Route path="/yearly_dues" element={<DuesPayment />} />
        <Route path="/make_donation" element={<Donations />} />
        <Route path="/dialog_form" element={<DialogForm />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>

      {/* MEMBER PRIVATE ROUTES*/}
      <Route path="/" exact element={<MemberLayout user={userLogin} />}>
        <Route element={<MemPersistLogin />}>
          <Route element={<RequireMember allowedRoles={[UserRoles.Member]} />}>
            <Route
              path="/curriculum_vitae"
              exact
              element={<MyCv member={mem} />}
            />
            <Route
              path="/update_profile_picture"
              exact
              element={<UpdateProfilePictuire member={mem} />}
            />
            <Route
              path="/view_curriculum_vitae"
              exact
              element={<ViewCV member={mem} />}
            />
            <Route
              path="/replace_curriculum_vitae"
              exact
              element={<ReplaceCV member={mem} />}
            />
            <Route path="/home" exact element={<Home member={mem} />} />
            <Route
              path="/member/dashboard"
              exact
              element={<MemberDashboard member={mem} />}
            />
            <Route
              path="/mandatory_payment_details/:id"
              exact
              element={<MandatoryPayments data={key} />}
            />
            <Route
              path="/other_payment_details/:id"
              exact
              element={<OtherPayments data={key} />}
            />
            {/* <Route path='/view_profile' exact element={< Profile member={mem} />} /> */}
            <Route
              path="/view_profile"
              exact
              element={<DisplayProfile member={mem} />}
            />
            <Route
              path="/update_profile"
              exact
              element={<UpdateProfile member={mem} />}
            />

            <Route
              path="/member_2m2_payments"
              exact
              element={<MemberTwoMTwoPayment member={mem} />}
            />
            <Route
              path="/member_regular_payments"
              exact
              element={<MemberRegularPayment member={mem} />}
            />
            <Route
              path="/member_ledger_account"
              exact
              element={<MemberLedger member={mem} />}
            />
            <Route
              path="/member_payment_transactions"
              exact
              element={<MemberPaymentTransactions member={mem} />}
            />
            <Route
              path="/member_statement"
              exact
              element={<MemberStatement member={mem} />}
            />
            <Route
              path="/pdf_service"
              exact
              element={<PdfServices member={mem} />}
            />

            <Route
              path="/contact_proforum"
              exact
              element={<ContactProforum member={mem} />}
            />
            <Route
              path="/change_member_password"
              exact
              element={<ChangePassword data={mem} />}
            />
          </Route>
        </Route>
      </Route>

      {/* ADMIN PRIVATE ROUTES */}
      <Route path="/" exact element={<AdminLayout />}>
        <Route element={<PersistLogin />}>
          <Route
            element={
              <RequireAuth
                allowedRoles={[
                  UserRoles.SuperAdmin,
                  UserRoles.SystemAdmin,
                  UserRoles.Regional_President,
                  UserRoles.DOperations,
                  UserRoles.DFinance,
                  UserRoles.SuperUser,
                  UserRoles.PollingAgent,
                ]}
              />
            }
          >
            <Route path="/callback/:id" element={<Callback />} />
            <Route path="/paginated_card" element={<PaginatedCard />} />
            <Route path="/paginating_card" element={<PaginatingCard />} />
            <Route
              path="/paginated_global_members"
              element={<PaginatedMembers />}
            />

            <Route path="/roles" element={<Roles />} />
            <Route
              path="/capture_old_members"
              element={<CaptureOldMembers />}
            />
            <Route
              path="/reset_user_password"
              element={<ResetUserPassword />}
            />
            <Route
              path="/reset_member_password"
              element={<ResetMemberPassword />}
            />
            <Route path="/change_region" element={<ChangeRegion />} />
            <Route path="/find_member" element={<FindMember />} />
            <Route path="/amend_region/:id" element={<AmendRegion />} />
            <Route path="/banks_home" element={<BankHome />} />

            {/* ADMIN DASHBOARD */}
            <Route
              path="/admin/dashboard"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <Dashboard allowedRoles={UserRoles} />
                  </Suspense>
                </ErrorBoundary>
              }
            />
            {/* APPLICATIONS */}
            <Route
              path="/new_applications"
              exact
              element={<Applications regional_email={auth.email} />}
            />
            <Route
              path="/regional_approvals"
              exact
              element={<RegionalApprovals email={auth.email} />}
            />
            <Route
              path="/regional_approve_form/:id"
              exact
              element={<RegionForm />}
            />
            <Route path="/dop_approvals" exact element={<DopApprovals />} />
            <Route path="/dop_approve_form/:id" exact element={<DopForm />} />
            <Route
              path="/approved_application/:id"
              exact
              element={<ApprovalForm />}
            />
            <Route
              path="/declined_applications"
              exact
              element={<DeclinedApplications />}
            />
            <Route
              path="/view_application/:id"
              exact
              element={<ViewApplication />}
            />

            {/* OPERATIONS */}
            <Route
              path="/regional_report_list"
              exact
              element={<RegionalReportList />}
            />
            <Route
              path="/view_regional_report/:id"
              exact
              element={<ViewRegionalReport />}
            />
            <Route
              path="/view_consolidated_report"
              exact
              element={<ViewConsolidatedReport />}
            />
            <Route
              path="/regional_reports"
              exact
              element={<OperationsReport />}
            />
            <Route
              path="/activation_response"
              exact
              element={<ActivationRequests />}
            />
            <Route path="/update_response" exact element={<UpdateRequests />} />
            <Route
              path="/messages_response"
              exact
              element={<ContactMessage />}
            />
            <Route path="/reply_message/:id" exact element={<ReplyMessage />} />

            {/* REGIONAL MEMBERSHIP */}
            <Route
              path="/regional_members"
              exact
              element={<RegionalMembers />}
            />
            <Route
              path="/view_regional_member/:id"
              exact
              element={<DisplayRegionalMember />}
            />
            <Route
              path="/active_regional_members"
              exact
              element={<ActiveRegionalMembers />}
            />
            <Route
              path="/inactive_regional_members"
              exact
              element={<InactiveRegionalMembers />}
            />

            <Route
              path="/regional_payment_transactions"
              exact
              element={<RegionalPaymentTransactions />}
            />
            <Route
              path="/view_regional_payment/:id"
              exact
              element={<ViewRegionalPayment pf_number={paymtPF} />}
            />

            <Route
              path="/regional_ledger_accounts"
              exact
              element={<RegionalLedgerAccounts />}
            />
            <Route
              path="/view_regional_ledger/:id"
              exact
              element={<ViewRegionalLedger />}
            />

            <Route
              path="/view_active_member/:id"
              exact
              element={<ViewActiveMember />}
            />
            <Route
              path="/view_inactive_member/:id"
              exact
              element={<ViewInactiveMember />}
            />

            {/* GLOBAL MEMBERSHIP */}
            <Route
              path="/active_members"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <ActiveMembers />
                  </Suspense>
                </ErrorBoundary>
              }
            />
            <Route
              path="/duplicate_records"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <DuplicateRecords />
                  </Suspense>
                </ErrorBoundary>
              }
            />
            <Route
              path="/inactive_members"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <InactiveMembers />
                  </Suspense>
                </ErrorBoundary>
              }
            />

            {/* GENERAL SETUP */}
            <Route
              path="/general_setup"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <GeneralSetup />
                  </Suspense>
                </ErrorBoundary>
              }
            />

            {/* ADMIN USERS */}
            <Route
              path="/admin_users"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <AdminUsers />
                  </Suspense>
                </ErrorBoundary>
              }
            />
            <Route path="/view_cvs" exact element={<CVManagement />} />
            <Route
              path="/member_profile_picture"
              exact
              element={<ProfilePictuires />}
            />
            <Route
              path="/upload_member_cv"
              exact
              element={<UploadMemberCV />}
            />
            <Route
              path="/online_users"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <OnlineUsers />
                  </Suspense>
                </ErrorBoundary>
              }
            />
            {/* PORTAL USERS */}
            <Route
              path="/create_portal_users"
              exact
              element={<CreatePortalUser />}
            />
            <Route
              path="/portal_users"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <PortalUsers />
                  </Suspense>
                </ErrorBoundary>
              }
            />
            {/* REGIONAL PRESIDENTS */}
            <Route
              path="/regional_presidents"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <RegionalPresidents />
                  </Suspense>
                </ErrorBoundary>
              }
            />

            {/* MEMBERSHIP */}
            <Route
              path="/global_members"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <Members />
                  </Suspense>
                </ErrorBoundary>
              }
            />
            <Route path="/view_member/:id" exact element={<DisplayMember />} />
            <Route path="/update_member/:id" exact element={<MemberUpdate />} />
            <Route
              path="/admin_regional_members"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <FindRegion />
                  </Suspense>
                </ErrorBoundary>
              }
            />

            {/* POLLING AGENTS */}
            <Route
              path="/polling_agents"
              element={
                <ErrorBoundary
                  FallbackComponent={ErrorFallback}
                  onReset={() => navigate("/")}
                >
                  <Suspense fallback={<SkeletonAdmin />}>
                    <PollingAgents />
                  </Suspense>
                </ErrorBoundary>
              }
            />

            {/* ACCOUNTS */}
            <Route
              path="/new_applicants"
              exact
              element={<NewApplicantMomoPayments />}
            />
            <Route
              path="/existing_members"
              exact
              element={<ExistingMemberMoMoPayments />}
            />
            <Route path="/manual_receipt" exact element={<ManualReceipt />} />
            <Route
              path="/payment_transactions"
              exact
              element={<PaymentTransactions />}
            />
            {/* <Route path='/view_payment/:id' exact element={< ViewPayment pf_number={paymtPF} />} /> */}
            <Route
              path="/view_payment/:id"
              exact
              element={<ViewPayment receipt={receiptNo} />}
            />
            <Route
              path="/payments_by_period"
              exact
              element={<PaymentByPeriod />}
            />
            <Route
              path="/payments_by_month"
              exact
              element={<PaymentByMonth />}
            />
            <Route path="/payments_by_mode" exact element={<PaymentByMode />} />
            <Route
              path="/payment_clearance"
              exact
              element={<PaymentClearance />}
            />
            <Route
              path="/update_clearance"
              exact
              element={<UpdateClearance />}
            />
            <Route
              path="/view_pending_payment/:id"
              exact
              element={<ViewPaymentClearance />}
            />

            {/* ACCOUNTS REPORTS*/}
            <Route path="/accounts_report" exact element={<AccountReports />} />
            <Route path="/2m2_payments" exact element={<TwomtwoPayments />} />
            <Route
              path="/mandatory_payments_report"
              exact
              element={<MandatoryPaymentsReport />}
            />
            <Route
              path="/mandatory_payments_by_date"
              exact
              element={<MandatoryPaymentsByDate />}
            />
            <Route
              path="/mandatory_payments_by_month"
              exact
              element={<MandatoryPaymentsByMonth />}
            />

            <Route path="/ledger_balances" exact element={<LedgerBalances />} />

            {/* PAYMENT TYPES */}
            <Route path="/payment_types" exact element={<PaymentTypes />} />
            <Route
              path="/add_payment_type"
              exact
              element={<AddPaymentType />}
            />
            <Route
              path="/edit_payment_type/:id"
              exact
              element={<EditPaymentType />}
            />
            <Route
              path="/view_payment_type/:id"
              exact
              element={<ViewPaymentType />}
            />

            {/* YEARLY PAYMENT */}
            <Route path="/yearly_payments" exact element={<YearlyPayments />} />
            <Route
              path="/add_yearly_payment"
              exact
              element={<AddYearlyPayment />}
            />
            <Route
              path="/view_yearly_payment/:id"
              exact
              element={<ViewYearlyPayment />}
            />
            <Route
              path="/edit_yearly_payment/:id"
              exact
              element={<EditYearlyPayment />}
            />

            {/* LEDGER ACCOUNT */}
            <Route path="/yearly_ledgers" exact element={<CreateLedgers />} />
            <Route path="/ledger_accounts" exact element={<LedgerAccounts />} />
            <Route path="/view_ledger/:id" exact element={<ViewLedger />} />
            <Route
              path="/good_standing_members"
              exact
              element={<GoodStanding />}
            />
            <Route path="/arrears_members" exact element={<InArrears />} />
            <Route
              path="/part_payment_members"
              exact
              element={<PartPayment />}
            />

            <Route
              path="/update_member_ledger"
              exact
              element={<UpdateLedger />}
            />
            {/* EXPENDITURE */}
            <Route path="/expenditure" exact element={<Expenditure />} />

            {/* REVENUE */}
            <Route path="/revenue" exact element={<Revenue />} />

            {/* <Route path='/revenue' exact element={< Revenue />} /> */}
            {/* <Route path='/view_expenditure/:id' exact element={< ViewExpenditure />} /> */}
            {/* <Route path='/edit_expenditure/:id' exact element={< EditExpenditure />} /> */}

            {/* REVENUE */}

            {/* <Route path='/account_reports' exact element={< AccountReports />} /> */}

            {/* <Route path='/view_ledger/:id' exact element={< ViewLedger />} />


						{/* CARD MANAGEMENT */}
            <Route path="/global_cards" exact element={<GlobalCards />} />
            <Route path="/view_card/:id" exact element={<ViewCard />} />
            <Route path="/pending_cards" exact element={<PendingCards />} />
            <Route
              path="/pending_confirmation"
              exact
              element={<PendingConfirmation />}
            />

            {/* REPORTS */}
            <Route
              path="/membership_reports"
              exact
              element={<MembershipReports />}
            />
            <Route
              path="/regional_membership_report"
              exact
              element={<RegionalMembershipReport />}
            />
            <Route
              path="/payments_reports"
              exact
              element={<PaymentReports />}
            />
            <Route
              path="/ledger_reports"
              exact
              element={<MembershipReports />}
            />

            {/* DEACTIVATION */}
            <Route
              path="/activation_management"
              element={<ActivationManagement />}
            />
            <Route
              path="/user_activation_management"
              element={<UserActivationManagement />}
            />

            {/* TRY RESOURCES */}
            <Route path="/template" element={<Template />} />
            <Route path="/multi_form" element={<MultiForm />} />
            <Route path="/table1" element={<Table1 />} />
            <Route path="/form1" element={<Form1 />} />
            <Route path="/change_form" element={<ChangeForm />} />
            <Route path="/my_form" element={<MyForm />} />
            <Route path="/pager" element={<Pager />} />
            <Route path="/whatsapp" element={<Whatsapp />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
